import { PRODUCT_TYPE } from '../constants/productType'

export interface ProductTypeProviderValuesInput {
  isWellbeingEnabled: boolean
  productType: PRODUCT_TYPE
  isUserLoggedIn?: boolean
  lastLoggedInUserProductType?: PRODUCT_TYPE
}

export interface ProductTypeProviderValues {
  isLyraSelect: boolean
  isWellbeing: boolean
  productType: PRODUCT_TYPE
}

/**
 * Derives the product theme context from the backend product type and the Wellbeing rollout flag.
 *
 * WFMH is the default product experience. Aurora is the theme for WFMH and Wellbeing, while
 * Lyra Select owns its product experience and theme decisions.
 * Lyra Select has its own Select-specific theme, microsite, and registration experience;
 * Wellbeing follows the same Aurora experience as WFMH.
 *
 * Logged-out flows use the last logged-in product type for product context, so the product (and
 * therefore the theme) stays stable across the logout transition. Wellbeing is exposed only when
 * its rollout flag is enabled.
 */
export const getProductTypeProviderValues = ({
  isWellbeingEnabled,
  isUserLoggedIn = true,
  productType,
  lastLoggedInUserProductType,
}: ProductTypeProviderValuesInput): ProductTypeProviderValues => {
  const isLyraSelect = productType === PRODUCT_TYPE.SELECT
  const isWellbeing = isWellbeingEnabled && productType === PRODUCT_TYPE.WELLBEING
  const activeProductType = isUserLoggedIn ? productType : lastLoggedInUserProductType
  const shouldExposeProductContext = activeProductType !== PRODUCT_TYPE.WELLBEING || isWellbeingEnabled

  return {
    isLyraSelect,
    isWellbeing,
    productType: shouldExposeProductContext && activeProductType ? activeProductType : PRODUCT_TYPE.WFMH,
  }
}
